module.exports = __webpack_public_path__ + "img/hc_pro_four_4.daa008cb.jpg";